import type { CSS } from '@stitches/react';
import { memo } from 'react';

import { ButtonGroup } from '@/components/shared/buttons/button-group';

interface ButtonDetailProps {
  url: string;
  label?: string;
}
export interface ButtonLinkProps {
  register: ButtonDetailProps;
  detail: ButtonDetailProps;
}
interface CarSelectionButtonProps {
  css?: CSS;
  modelName: string;
  link: ButtonLinkProps;
  index: number;
}

export const CarSelectionButton: React.FC<CarSelectionButtonProps> = memo(
  ({ css, modelName, index, link }) => {
    return (
      <ButtonGroup
        data-test={`panel_ctaButton_${index}`}
        css={{ maxWidth: '$size-56', margin: '0 auto', ...css }}
        justify="center"
        size="md"
        isFull
        buttons={[
          {
            type: 'primary',
            label: link?.register?.label ?? 'สนใจรถ',
            url: link?.register?.url,
          },
          {
            type: 'border',
            label: link?.detail?.label ?? 'ดูรายละเอียด',
            url: link?.detail?.url,
            border: true,
          },
        ]}
        tracking={{
          dataTrack: 'product-compare-cta',
          dataTrackValue: modelName,
        }}
        test={{ dataTest: 'compare_ctaButton', dataTestValue: modelName }}
      />
    );
  }
);
CarSelectionButton.displayName = 'CarSelectionButton';
